import React from 'react';
import { cn } from '../../utils/cn';

const DialogContext = React.createContext();

export function Dialog({ open, onOpenChange, children }) {
  const childArray = React.Children.toArray(children);
  const triggers = childArray.filter(child => child.type === DialogTrigger);
  const rest = childArray.filter(child => child.type !== DialogTrigger);

  return (
    <DialogContext.Provider value={{ open, onOpenChange }}>
      {triggers}
      {open && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div
            className="fixed inset-0 bg-black/50"
            onClick={() => onOpenChange?.(false)}
          />
          <div className="relative z-50 w-full max-w-lg mx-4">
            {rest}
          </div>
        </div>
      )}
    </DialogContext.Provider>
  );
}

export function DialogTrigger({ asChild, children, ...props }) {
  const { onOpenChange } = React.useContext(DialogContext);
  
  if (asChild) {
    return React.cloneElement(React.Children.only(children), {
      onClick: () => onOpenChange?.(true),
      ...props,
    });
  }
  
  return (
    <button onClick={() => onOpenChange?.(true)} {...props}>
      {children}
    </button>
  );
}

export function DialogContent({ children, className, ...props }) {
  return (
    <div
      className={cn(
        'bg-white rounded-lg shadow-lg p-6 w-full max-w-lg max-h-[90vh] overflow-y-auto',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}

export function DialogHeader({ children, className, ...props }) {
  return (
    <div className={cn('mb-4', className)} {...props}>
      {children}
    </div>
  );
}

export function DialogTitle({ children, className, ...props }) {
  return (
    <h2 className={cn('text-xl font-semibold text-slate-900', className)} {...props}>
      {children}
    </h2>
  );
}

export function DialogDescription({ children, className, ...props }) {
  return (
    <p className={cn('text-sm text-slate-500 mt-1', className)} {...props}>
      {children}
    </p>
  );
}

